type Offre = {
  rang: number; offreCode: string; libelle: string; argument: string;
  beneficeChiffrable: string | null; ouvrirDessus: boolean; signauxDeclencheurs: string[];
};

export function ClassementOffres({ offres }: { offres: Offre[] }) {
  if (offres.length === 0) return <p className="etat">Aucune offre calculée : aucun constat retenu.</p>;

  return (
    <>
      <div className="panel gris">
        <h2 className="blocktitle">Règle d'engagement</h2>
        <p>Ouvrir uniquement sur le rang 1. Les suivantes servent au rebond, une fois la confiance établie.</p>
      </div>
      {offres.map(o => (
        <article key={o.offreCode} className={`offre ${o.rang === 1 ? "r1" : ""}`}>
          <div className="hd">
            <span className="rangn">{o.rang}</span>
            <h3>{o.libelle}</h3>
            {!o.ouvrirDessus && <span className="warn">ne pas ouvrir dessus</span>}
          </div>
          <p>{o.argument}</p>
          {o.beneficeChiffrable && <p className="benefice">{o.beneficeChiffrable}</p>}
          {o.signauxDeclencheurs.length > 0 && (
            <p className="mono petit mut">Déclenchée par : {o.signauxDeclencheurs.join(" · ")}</p>
          )}
        </article>
      ))}
    </>
  );
}
